import browser from '@/libs/browser';

// 跳题类型。1表示按选项跳题，题目是单选时可以按选项跳题；2表示无条件跳题
export const QuestionJumpType = {
    byOption: '1',
    byNothing: '2'
};

// 1 表示不跳转，顺序显示下一题；2 直接结束作答；3 提交为无效答卷；4 跳转到目标题目
export const OptionJumpType = {
    orderNext: '1',
    toEnd: '2',
    submitInvalid: '3',
    toTarget: '4'
};

// 题目的必填和非必填
export const QuestionRequire = {
    yes: '1',
    no: '0'
};

/**
 * 题目类型
 */
export const QuestionType = {
    single: '1', // 单选
    multi: '2', // 多选
    fillblank: '3', // 填空
    page: '4' // 分页
};
/**
 * 多选题题目跳转条件（参考问卷星）
 */
export const MutipleJumpCondition = {
    selectAny: '1', // 选择任一个
    selectAll: '2', // 选择全部
    notSelectAny: '3', // 没有选择任一个
    notSelectAll: '4' // 没有选择全部
};

/**
 * 是否需要封面
 */
export const CoverFlag = {
    yes: '1',
    no: '0'
};

/**
 * 页面通顶模式
 */
export const FullTopMode = {
    transparent: browser.isAndroid() ? '2' : '3',
    normal: '1'
};

/**
 * 是否开启东财原生端分享
 */
export const ShareFlag = {
    yes: true,
    no: false
};

/**
 * 是否抽奖
 */
export const RewardFlag = {
    yes: '1',
    no: '0'
};

/**
 * 奖励类型：1积分，2红包，3卡券，4：非卡券类，5：现金红包
 */
export const RewardType = {
    integral: 1,
    redpackage: 2,
    coupon: 3,
    notcoupon: 4,
    cash: 5
};

/**
 * 题目关联关系
 */
export const RelType = {
    and: 'and',
    or: 'or'
};

/**
 * 一些特殊的操作
 */
export const QuestionSepcialFlag = {
    submitInvalid: 'invalid'
};
/**
 * 选项类型
 */
export const OptionType = {
    check: '1',
    checkAndFillbank: '2'
};
